import Component from '../../classes/Component';
import { $events } from '../../helpers/events';
import { isElement, debounce, declensionOfNumber } from '../../helpers/_utilities';
import { $dom } from '../../helpers/dom';
import variables from '../../variables';
import gsap from 'gsap';
import { DATA_URL } from '../../modules/backend';
import { $style } from '../../helpers/style';
import Draggable from 'gsap/Draggable';

const { attr, get, getAll, addClass, removeClass, hasClass, each } = $dom;
const { lg, sm } = variables.breakpoints;

gsap.registerPlugin(Draggable);

let mapData;

const mapId = 'offices-map';

const mapMainSelector = '.js-map-main';
const mapMainGroupSelector = '.js-map-region-group';
const mapContentSelector = '.js-office-map-content';
const mapContentItemSelector = '.js-map-content-item';
const mapCloseSelector = '.js-office-map-close';
const mapContentItemClose = '.js-item-close'
const mapRegionSelector = '.js-map-region';
const mapTipSelector = '.js-map-tip';

const mapPointSelector = '.js-map-point';
const mapRectSelector = '.map-rect-item';
const mapPointsListSelector = '.js-map-points-list';
const mapPointMarkerSelector = '.js-map-point-marker';

const mapDesignationsSelector = '.js-offices-designations';

const COUNT_WORDS = ['представительство', 'представительства', 'представительств'];

export default function interactiveMap() {

  const mapContentHeaderElement = get('.offices__map-content-header');
  const mapContentItemListElement = get('.offices__map-content-list');
  const mapContentTitleElement = get('.js-content-title');
  const mapContentRepElement = get('.js-content-rep');

  const mapContentTemplate = get('#offices-map-content-item').innerHTML;
  const mapRectTemplate = get('#map-rect').innerHTML;
  const mapPointTemplate = get('#map-point').innerHTML;

  const mapContentListEmptyTemplate = get('#offices-map-content-list-empty').innerHTML;

  const mapMain = get(mapMainSelector);
  const mapRoot = get(`#${mapId}`);
  const animationDuration = .5;

  const regionArr = getAll('.offices__map-region');

  let isZoomIn = false;
  let isMobile = false;
  let pointsArr = [];
  let rectsArr = [];
  let mapAnimation = null;
  let mapDesignations = null;
  let contentSpawnAnimation = null;
  let contentDisapearAnimation = null;
  let currentRegionId = null;

  let mapWidth = mapMain.getBoundingClientRect().width;
  let mapGroupWidth = get(mapMainGroupSelector).getBoundingClientRect().width;
  let mapOffset = $style.offset(mapMain);

  const mainMapViewbox = attr(mapMain, 'viewBox').split(' ');

  let mapRect = get(mapMainSelector).getBoundingClientRect();

  const originalViewBox = {
    x: mainMapViewbox[0],
    y: mainMapViewbox[1],
    width: mainMapViewbox[2],
    height: mainMapViewbox[3],
  }
  // console.log(originalViewBox);

  const insertElement = (element, template) => element.insertAdjacentHTML('beforeend', template)

  const mapDrag = new Draggable.create(mapMainSelector, {
    type: 'x',
    bounds: mapRoot,
    overshootTolerance: 0,
  })

  mapDrag[0].disable();

  async function updatePointPositions(points, rects) {

    points.map((elem, i) => {
      gsap.set(elem, {
        top: $style.offset(rects[i]).top - $style.offset(mapMain).top,
        left: $style.offset(rects[i]).left - $style.offset(mapMain).left,
      })
    })
  }

  const resetupMapOffset = () => mapOffset = $style.offset(mapMain);

  const checkIfMobile = () => (window.innerWidth < [lg]) ? true : false

  const setupMapDrag = (value) => (value) ? mapDrag[0].enable() : mapDrag[0].disable();

  let getMapData = async () => {
    const response = await fetch(DATA_URL);

    let mapdata = await response.json();
    let data = Object.values(mapdata);

    return data;
  }

  const updateMapRect = () => {
    mapRect = get(mapMainSelector).getBoundingClientRect();
  }

  const setClasses = async () => {
    mapData = await getMapData();

    mapData.map(data => {

      regionArr.map(elem => {

        if (attr(elem, "id") == data.regionId) {
          addClass(elem, `offices__map-region--${data.repType}`)

          elem.dataset.regionName = data.regionName

          if (!hasClass(elem, `js-map-region`)) addClass(elem, `js-map-region`)

          if (data.isForeign) {
            addClass(elem, `offices__map-region--foreign`)
          }
        }
      })
    })
  }

  const setMapRectPositions = async () => {

    mapData = await getMapData();

    mapData.map(data => {

      data.representation.map(rep => {
        const resultTemplate = Object.keys(rep)
          .reduce((acc, key) => {
            if (rep.hasOwnProperty(key)) {
              const val = rep[key];
              acc = acc.replaceAll(`{{${key}}}`, val)
            }
            return acc;
          }, mapRectTemplate)

        regionArr.map(elem => {
          if (attr(elem, "id") == data.regionId) {
            let newResultTemplate = resultTemplate.replaceAll("{{regionId}}", data.regionId);
            insertElement(get(mapPointSelector, elem), newResultTemplate)
          }
        })
      })
    })
  }

  const setMapPointPositions = async () => {

    mapData = await getMapData();

    mapData.map(data => {

      data.representation.map(rep => {
        const resultTemplate = Object.keys(rep)
          .reduce((acc, key) => {
            if (rep.hasOwnProperty(key)) {
              const val = rep[key];
              acc = acc.replaceAll(`{{${key}}}`, val)
            }
            return acc;
          }, mapPointTemplate)

        regionArr.map(elem => {

          if (attr(elem, "id") == data.regionId) {
            let newResultTemplate = resultTemplate.replaceAll("{{regionId}}", data.regionId)
            newResultTemplate = newResultTemplate.replaceAll("{{repType}}", data.repType)
            insertElement(get(mapPointsListSelector), newResultTemplate)
          }
        })

        let points = getAll(mapPointMarkerSelector);
        let rects = getAll(mapRectSelector);

        updatePointPositions(points, rects)
      })
    })
  }

  function setPreserveAspectRatio(target, value) {
    target.setAttribute("preserveAspectRatio", value)
  }

  const changeMapAttr = () => (checkIfMobile()) ? setPreserveAspectRatio(mapMain, "xMinYMin meet") : setPreserveAspectRatio(mapMain, "xMidYMid meet");

  const setCorrectZoomNumbers = (rect) => {
    const contentWidth = get(mapContentSelector).clientWidth;
    const contentHeight = get(mapContentSelector).clientHeight;

    let
      x = rect.x,
      y = rect.y,
      width = rect.width,
      height = rect.height,
      maxWidth = 80,
      maxHeight = 70;

    if (window.innerWidth <= [sm]) {

      if (rect.width <= maxWidth) {
        x = rect.x - maxWidth / 8
        width = maxWidth * 2;
      }

      if (rect.height <= maxHeight) {
        height = maxHeight * 2
        y = rect.y - maxHeight / 2
      }

      if (rect.width > 100 && rect.width <= 300) {
        x = rect.x - rect.width / 20
        width = rect.width * 4
      }

      if (rect.width > 300) {
        x = rect.x - rect.width / 20
        width = rect.width * 4
      }

      if (rect.height > 70 && rect.height < 300) {
        y = rect.y - rect.height / 20
        height = rect.height + contentHeight / 2
      }

      if (rect.height > 300) {
        x = rect.x - rect.width / 2
        height = rect.height + contentHeight * 1.2
      }
    } else if (!checkIfMobile()) {

      if (rect.width <= maxWidth) {
        width = maxWidth * 4;
        x = rect.x - maxWidth / 2;
      }

      if (rect.height <= maxHeight) {
        height = maxHeight * 2
        y = rect.y - maxHeight / 2
      }

      if (rect.width > 80 && rect.width <= 300) {
        x = rect.x - rect.width / 20
        width = rect.width + (contentWidth / 2)
      }

      if (rect.width > 300) {
        x = rect.x - rect.width / 20
        width = rect.width + contentWidth
      }

    } else if (checkIfMobile()) {

      if (rect.width <= maxWidth) {
        width = maxWidth;
        x = rect.x - maxWidth / 2
      }

      if (rect.height <= maxHeight) {
        height = maxHeight * 2
        y = rect.y - maxHeight / 2
      }

      if (rect.width > 100 && rect.width <= 300) {
        x = rect.x - rect.width / 4
        width = rect.width * 2.5
      }

      if (rect.width > 300) {
        x = rect.x - rect.width / 20
        width = rect.width * 2
      }

      if (rect.height > 30 && rect.height < 300) {
        y = rect.y - rect.height / 20
        height = rect.height + contentHeight / 2
      }

      if (rect.height > 300) {
        x = rect.x - rect.width / 2
        height = rect.height + contentHeight * 1.2
      }
    }

    return { x, y, width, height }
  }

  const zoomInRegion = (mapData, region, regionId) => {
    isZoomIn = true;

    addClass(region, 'region-' + variables.classNames.active)
    addClass(mapDesignationsSelector, variables.classNames.active)

    setupMapDrag(checkIfMobile() && !isZoomIn);

    gsap.set(mapMainSelector, { pointerEvents: "none", userSelect: "none" })

    pointsArr = getAll(mapPointMarkerSelector).filter(elem => attr(elem, "data-region-bind") == regionId);
    rectsArr = getAll(mapRectSelector).filter(elem => attr(elem, "data-region-bind") == regionId);

    mapData.map(data => {
      if (data.regionId == regionId) {

        mapContentTitleElement.textContent = data.regionName;
        mapContentRepElement.textContent = `${data.representation.length} ${declensionOfNumber(data.representation.length, COUNT_WORDS)}`

        if (data.representation.length == 0) {
          insertElement(mapContentItemListElement, mapContentListEmptyTemplate);
          return
        }

        mapContentItemListElement.innerHTML = '';

        data.representation.map(rep => {
          const resultTemplate = Object.keys(rep)
            .reduce((acc, key) => {
              if (rep.hasOwnProperty(key)) {
                const val = rep[key];

                acc = acc.replaceAll(`{{${key}}}`, val)
              }
              return acc;
            }, mapContentTemplate)

          let newResultTemplate = resultTemplate.replaceAll(`{{repType}}`, data.repType);
          insertElement(mapContentItemListElement, newResultTemplate)
        })
      }
    })

    const rect = region.getBBox();

    const newRect = setCorrectZoomNumbers(rect);

    mapAnimation = gsap.to(mapMainSelector, animationDuration, {
      onComplete() {
        updatePointPositions(pointsArr, rectsArr);

        gsap.set(mapMainSelector, { pointerEvents: "auto", userSelect: "auto" })
      },
      x: 0,
      y: 0,
      attr: { viewBox: `${newRect.x} ${newRect.y} ${newRect.width} ${newRect.height}` },
    })

    gsap.set(mapContentSelector, { opacity: 1 });
    gsap.set(mapPointsListSelector, { pointerEvents: "all" })

    if (pointsArr.length != 0) {
      contentSpawnAnimation = gsap.timeline()
        .to(mapContentSelector, animationDuration, { translateX: 0 })
        .to(pointsArr, animationDuration, { opacity: 1, pointerEvents: "auto", userSelect: "auto" })
        .restart()
    } else {
      contentSpawnAnimation = gsap.timeline()
        .to(mapContentSelector, animationDuration, { translateX: 0 })
        .restart()
    }
  }

  // const zoomOutRegion = () => {

  //   isZoomIn = false;

  //   setupMapDrag(checkIfMobile() && !isZoomIn);

  //   mapContentItemListElement.innerHTML = '';

  //   removeClass(mapRegionSelector, 'region-' + variables.classNames.active);
  //   removeClass(mapContentSelector, variables.classNames.active);
  //   removeClass(mapDesignationsSelector, variables.classNames.active)

  //   mapAnimation.reverse();

  //   getAll(mapPointMarkerSelector).map(element => {
  //     removeClass(element, variables.classNames.active)
  //   });

  //   gsap.set(mapPointsListSelector, {
  //     pointerEvents: "none",
  //   })
  //   gsap.set(mapMainSelector, { pointerEvents: "none", userSelect: "none" })

  //   if (pointsArr.length != 0) {
  //     contentDisapearAnimation = gsap.timeline({
  //       onComplete() {
  //         gsap.set(mapMainSelector, { pointerEvents: "auto", userSelect: "auto" })
  //       }
  //     })
  //       .to(mapContentSelector, animationDuration, { opacity: 0 })
  //       .to(pointsArr, animationDuration, { opacity: 0, pointerEvents: "none", userSelect: "none" }, "<")
  //       .to(mapContentSelector, animationDuration, { translateX: '120%' })
  //       .restart();
  //   } else {
  //     contentDisapearAnimation = gsap.timeline()
  //       .to(mapContentSelector, animationDuration, { opacity: 0 })
  //       .to(mapContentSelector, animationDuration, { translateX: '120%' })
  //       .restart();
  //   }
  // }

  const handleMapClick = async event => {

    const region = event.target.closest(mapRegionSelector);
    const regionId = attr(region, 'id');

    if (!isElement(region)) return

    mapData = await getMapData();

    if (!isZoomIn) {
      zoomInRegion(mapData, region, regionId);

      currentRegionId = regionId;
    }

    if (isZoomIn && currentRegionId != regionId) {
      // console.log('another region');

      currentRegionId = regionId

      setupMapDrag(checkIfMobile() && !isZoomIn);

      mapContentItemListElement.innerHTML = '';

      removeClass(mapRegionSelector, 'region-' + variables.classNames.active);

      getAll(mapPointMarkerSelector).map(element => {
        removeClass(element, variables.classNames.active)
      });

      gsap.set(mapPointsListSelector, {
        pointerEvents: "none",
      })
      gsap.set(mapMainSelector, { pointerEvents: "none", userSelect: "none" })

      if (pointsArr.length != 0) {
        contentDisapearAnimation = gsap.timeline({
          onComplete() {
            gsap.set(mapMainSelector, { pointerEvents: "auto", userSelect: "auto" })
          }
        })
          .to(pointsArr, animationDuration, { opacity: 0, pointerEvents: "none", userSelect: "none" }, "<")
          .restart();
      } else {
        contentDisapearAnimation = gsap.timeline()
          .restart();
      }
      
      zoomInRegion(mapData, region, regionId);
    }
  }

  const hideAll = () => {
    isZoomIn = false;

    setupMapDrag(checkIfMobile() && !isZoomIn);

    mapContentItemListElement.innerHTML = '';

    removeClass(mapRegionSelector, 'region-' + variables.classNames.active);
    removeClass(mapContentSelector, variables.classNames.active);
    removeClass(mapDesignationsSelector, variables.classNames.active)

    getAll(mapPointMarkerSelector).map(element => {
      removeClass(element, variables.classNames.active)
    });

    gsap.to(mapMainSelector, animationDuration, {
      onComplete() {
        updatePointPositions(pointsArr, rectsArr);

        gsap.set(mapMainSelector, { pointerEvents: "auto", userSelect: "auto" })
      },
      x: 0,
      y: 0,
      attr: { viewBox: `${originalViewBox.x} ${originalViewBox.y} ${originalViewBox.width} ${originalViewBox.height}` },
    })

    gsap.set(mapPointsListSelector, {
      pointerEvents: "none",
    })

    gsap.set(mapMainSelector, { pointerEvents: "none", userSelect: "none" })

    if (pointsArr.length != 0) {
      contentDisapearAnimation = gsap.timeline({
        onComplete() {
          gsap.set(mapMainSelector, { pointerEvents: "auto", userSelect: "auto" })
        }
      })
        .to(mapContentSelector, animationDuration, { opacity: 0 })
        .to(pointsArr, animationDuration, { opacity: 0, pointerEvents: "none", userSelect: "none" }, "<")
        .to(mapContentSelector, animationDuration, { translateX: '120%' })
        .restart();
    } else {
      contentDisapearAnimation = gsap.timeline()
        .to(mapContentSelector, animationDuration, { opacity: 0 })
        .to(mapContentSelector, animationDuration, { translateX: '120%' })
        .restart();
    }
  }

  const handleMarkerClick = event => {

    const target = event.target.closest(mapPointMarkerSelector);

    if (target) {
      const targetCity = attr(target, "data-city-bind")
      const contentElement = getAll(mapContentItemSelector, mapContentSelector);
      const markerElements = getAll(mapPointMarkerSelector)

      // if (hasClass(mapContentHeaderElement, variables.classNames.active)) removeClass(mapContentHeaderElement, variables.classNames.active)

      // addClass(mapContentHeaderElement, variables.classNames.active)

      removeClass(markerElements, variables.classNames.active)
      removeClass(contentElement, variables.classNames.active)

      each(contentElement, elem => {

        if (attr(elem, "data-city-bind") == targetCity) {

          addClass(target, variables.classNames.active)
          addClass(elem, variables.classNames.active)

          mapContentItemListElement.scrollTo({
            top: elem.offsetTop - mapContentItemListElement.offsetTop,
            behavior: 'smooth',
          })
        }
      })
    }
  }

  const handleCloseItem = event => {
    const target = event.target.closest(mapContentItemClose);

    const contentElement = getAll(mapContentItemSelector, mapContentSelector);

    if (target) {
      removeClass(target, variables.classNames.active)
      // removeClass(mapContentHeaderElement, variables.classNames.active)
      removeClass(contentElement, variables.classNames.active)
      
      getAll(mapPointMarkerSelector).map(element => {
        removeClass(element, variables.classNames.active)
      });
    }
  }

  const handleOutsideClick = event => (!mapRoot.contains(event.target) && hideAll());

  return new Component({
    name: 'map',
    requiredSelector: `#${mapId}`,
    onInit() {
      setClasses();
      setMapRectPositions();
      setMapPointPositions();
      setupMapDrag(checkIfMobile());
      changeMapAttr();

      $events.resize('on', setupMapDrag);
      $events.resize('on', resetupMapOffset);
      $events.resize('on', checkIfMobile);
      $events.resize('on', changeMapAttr);
      $events.resize('on', updateMapRect);

      $events.delegate
        .on('tap click', `#${mapId}`, handleMapClick)
        .on('tap click', mapPointMarkerSelector, handleMarkerClick)
        .on('tap click', document, handleOutsideClick)
        .on('tap click', mapCloseSelector, hideAll)
        .on('tap click', mapContentItemClose, handleCloseItem)
    },
    onDestroy() {

      $events.resize('off', setupMapDrag)
      $events.resize('off', resetupMapOffset);
      $events.resize('off', checkIfMobile);
      $events.resize('off', changeMapAttr);

      $events.delegate
        .off('tap click', `#${mapId}`, handleMapClick)
        .off('tap click', mapPointMarkerSelector, handleMarkerClick)
        .off('tap click', document, handleOutsideClick)
        .off('tap click', mapCloseSelector, hideAll)
        .off('tap click', mapContentItemClose, handleCloseItem)
    }
  })
}